import React from "react";
import {
  DialogContent,
} from "@mui/material";
import { Modal } from "components/haven-design";
import BuildingDetailsShort from "./building-details-short";
import { BuildingType } from "./building-form";
import UnitList from "./unit-list";


const BuildingDetailsModal: React.FC<BuildingType & {
  open: boolean,
  handleClose: () => void,
}> = ({ open, handleClose, ...building }) => (
  <Modal
    isOpen={open}
    title={<BuildingDetailsShort {...building} />}
    fullScreen
    onRequestClose={handleClose}
  >
    <DialogContent>
      <UnitList buildingId={building.id} />
    </DialogContent>
  </Modal>
);

export default BuildingDetailsModal;
